<script setup lang="ts">

</script>
<template>
    <div class="bg-slate-200  rounded-lg shadow-md p-3 border-1 border-slate-300">
        <slot />
    </div>
</template>
